<template>
	<el-upload class="upload-demo" ref="upload" action="" :accept="acceptType" :auto-upload="false" :limit="1"
		:before-remove="beforeRemove" :on-exceed="handleExceed" :file-list="fileList" :on-change="getFile">
		<el-button size="small" type="primary"><i class="el-icon-upload pr5"></i>点击上传</el-button>
	</el-upload>
</template>

<script>
	export default {
		props: {
			fileName: String,
			acceptType: {
				type: String,
				default: ".doc,.docx,.pdf"
			}
		},

		data() {
			return {
				fileList: [],
			};
		},

		watch: {
			fileName: function(newVal, oldVal) {
				let fileList = [{name: newVal}];
				this.fileList = fileList;
			}
		},

		methods: {
			// 选择的文件超出限制范围
			handleExceed(files, fileList) {
				this.$message.warning(`超出文章选择上限`);
			},

			// 删除上传的文件
			beforeRemove(file, fileList) {
				this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.upArticle = "";
					this.fileList = [];
					let data = {
						name: "",
						url: "置空了,"
					};
					this.$emit("upCallback", data);
					return true;
				});
				return false;
			},

			// 上传文件获取文件信息和base64加密
			getFile(file, fileList) {
				this.upArticle = file.raw.name;
				console.log(file);
				this.getBase64(file.raw).then((res) => {
					let data = {
						name: file.raw.name,
						url: res
					};
					this.$emit("upCallback", data);
				});
			},

			getBase64(file) {
				return new Promise(function(resolve, reject) {
					let reader = new FileReader();
					let imgResult = "";
					reader.readAsDataURL(file);
					reader.onload = function() {
						imgResult = reader.result;
					};
					reader.onerror = function(error) {
						reject(error);
					};
					reader.onloadend = function() {
						resolve(imgResult);
					};
				});
			},
		},
	};
</script>
<style lang="scss">
</style>
